import { EnvironmentModel } from "../app/environment.service";


export const environment: EnvironmentModel = {
  production: false,
  baseUrl:
    'https://api.catnw8-knorrbrem1-s1-public.model-t.cc.commerce.ondemand.com/',
  //baseUrl:"https://localhost:9002/",
  googleReCaptchaKey: '6LdC4kkqAAAAAEuDmkMpP4hf-E6k_6pjmYABn_LG',
};
